// src/App.js

import React from 'react';
import ListaDeCompras from './components/ListaDeCompras';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <ListaDeCompras />   
      <Footer />    
    </div>
  );
}

export default App;
